import {
  Alert,
  AlertProps,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import {
  ExtensionAction,
  ExtensionMessageType,
  GetExtensionsMessagesQuery,
} from "../../../graphql/generated";
import { useState } from "react";
import { testIds } from "./ExtensionsMessages.testIds";

type ExtensionMessageData = GetExtensionsMessagesQuery["extensionsMessages"][0];

export type ExtensionMessagesProps = {
  messages: ExtensionMessageData[];
  onActionWidgetClose?: () => void;
};

const messageTypeToSeverity: {
  [key in ExtensionMessageType]: AlertProps["severity"];
} = {
  [ExtensionMessageType.Error]: "error",
  [ExtensionMessageType.Warning]: "warning",
  [ExtensionMessageType.Info]: "info",
};

const ExtensionsMessages = ({
  messages,
  onActionWidgetClose,
}: ExtensionMessagesProps) => {
  const [openAction, setOpenAction] = useState<ExtensionAction | null>(null);

  return (
    <Stack>
      {messages.map((message) => (
        <Alert
          severity={messageTypeToSeverity[message.type]}
          action={
            message.actions?.length ? (
              <Button data-testid={`${
                  testIds.extensionsMessagesOpenAction
                }-${`${message.extensionName}-${message.type}-${message.text}`}`}
                onClick={() => {
                  setOpenAction(message.actions?.[0] || null);
                }}
              >
                {message.actions[0].text}
              </Button>
            ) : undefined
          }
        >
          Extension {message.extensionName}: {message.text}
        </Alert>
      ))}

      <Dialog
        open={!!openAction}
        onClose={() => {
          setOpenAction(null);
        }}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>{openAction?.text}</DialogTitle>
        <DialogContent
          sx={{
            minHeight: 600,
          }}
        >
          {openAction ? (
            <iframe
              title="Extensions Messages"
              name="extensions-messages-open-action"
              src={openAction.url}
              style={{
                width: "100%",
                minHeight: 600,
              }}
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button data-testid={testIds.extensionsMessagesClose}
            onClick={() => {
              setOpenAction(null);
              onActionWidgetClose?.();
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default ExtensionsMessages;
